<template>
  <div class="module-block module-block-recapitulative vanguard-order-recap-container">
    <h4>{{ $t('billingRecap.title') }}</h4>

    <div v-for="choice in choices" :key="`choice-${choice.id}`">
      <div class="row module-block-offer-choice-name">
        <div class="col-sm-6 col-md-6 col-lg-2">
          <span>{{ $t('billingRecap.choiceName') }}</span>
        </div>
        <div v-if="choice.description" class="col-sm-6 col-md-6 col-lg-10">
          <div v-html="choice.description"></div>
          <span v-if="choice.name" class="text-muted">
            (<span class="font-italic">{{ $t('billingRecap.choiceCode') }}: <span v-html="choice.name"></span></span>)
          </span>
        </div>
        <div v-else class="col-sm-6 col-md-6 col-lg-10">
          <span v-html="choice.name"></span>
        </div>
      </div>

      <div v-if="choice && choice.longDescription" class="row module-block-offer-long-description">
        <div class="col-sm-6 col-md-6 col-lg-2">
          <span>{{ $t('billingRecap.description') }}</span>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-10" v-html="choice.longDescription"></div>
      </div>

      <hr>
    </div>

    <div class="row module-block-payment-at-order-time module-block-recapitulative-max-width pt-2">
      <div class="col-sm-6 col-md-6 col-lg-12">
        <strong>{{ $t('billingRecap.paymentAtOrderTime') }}</strong>
      </div>
    </div>

    <div v-for="choice in choices" :key="`choice-price-${choice.id}`">
      <div class="row module-block-offer-price module-block-recapitulative-max-width">
        <div class="col-sm-6 col-md-6 col-lg-8">
          <div v-if="choice.description" v-html="choice.description"></div>
          <div v-else-if="choice.name" v-html="choice.name"></div>
          <div v-else>
            <span>{{ $t('billingRecap.price') }}</span>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4 text-right text-nowrap">
          <span>{{ presentFloat(choice.price) }}</span>
          <span>{{ currencyIsoCode }}</span>
        </div>
      </div>
    </div>

    <div class="row module-block-offer-total module-block-recapitulative-max-width">
      <div class="col-sm-6 col-md-6 col-lg-8">
        <strong>{{ $t('billingRecap.orderTotal') }}</strong>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-4 text-right text-nowrap font-weight-bold">
        <amount-total :force-float="true"></amount-total>
        <span>{{ currencyIsoCode }}</span>
      </div>
    </div>

    <div v-if="paymentMethod" class="row module-block-offer-choice-payment-method module-block-recapitulative-max-width">
      <div class="col-sm-6 col-md-6 col-lg-8">
        <span>{{ $t('billingRecap.paymentMethod') }}</span>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-4 text-right text-nowrap">
        {{ Utils.capitalizeFirstLetter($t('all.' + paymentMethod)) }}
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import VanguardConfig from '../../../config/vanguard';
import Utils from '../../common/modules/utils';

import AmountTotal from './variables/amount-total.vue';

export default {
  components: {
    AmountTotal
  },
  methods: {
    presentFloat(price) {
      return parseFloat(price).toFixed(2);
    }
  },
  computed: {
    ...mapGetters([
      'orderFormConfig', // All orderFormConfig
      'choiceList', // Selected choices (mapped by stackLetter)
      'paymentMethod',
      'recurrence'
    ]),
    Utils() {
      return Utils;
    },
    currencyIsoCode() {
      return VanguardConfig.currencyIsoCode;
    },
    choices() {
      const choices = [];

      if (this.orderFormConfig === null) {
        return choices;
      }

      this.choiceList.forEach(stackLetter => {
        const choice = this.orderFormConfig.choices.find(c => {
          if (c.paymentMethod === this.paymentMethod &&
            c.recurrence === this.recurrence &&
            c.stackLetter === stackLetter) {
            return true;
          }

          return false;
        });

        if (choice) {
          choices.push(choice);
        }
      });

      return choices;
    }
  }
};
</script>



// WEBPACK FOOTER //
// order-recap.vue?70a7e6be